import { Component, Injectable, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AuthenticationService, TestData, TokenPayload } from '../services/authentication.service';
import { Router } from '@angular/router';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef} from '@angular/core';
import { NgForm } from '@angular/forms';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSortModule, MatSort} from '@angular/material/sort';
import { AdminService } from '../services/admin.service';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './test_scheduler.component.html',
  styleUrls: ['./test_scheduler.component.scss']
})
@Injectable()
export class TestSchedulerComponent implements OnInit {
  displayedColumns: string[] = ['S.No.','first_name','email','phone','Actions'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  searchKey: string;
  dataSource: MatTableDataSource<any>;
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  details: boolean;
  overall: boolean;
  evaluate: boolean;
  user;
  fname;
  lname;
  faTimes = faTimes;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  isCustomStyleApplied: boolean = false;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  userEvaluator: boolean;


  constructor(private auth: AuthenticationService, private router: Router,
              private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef,private adminservice: AdminService,media: MediaMatcher) {
    this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  columns: string[];
  // tslint:disable-next-line: member-ordering

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };


  ngOnInit() {
    this.getAccess();
    this.columns = this.auth.getColumnsB();
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
   }

   getScreenSize(): void {
    this.screenWidth = window.innerWidth;
   
    this.screenHeight = window.innerHeight;
   
  }
 
applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
      
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
        
      }
    }
  }

  //  getAccess(){
  //   this.user = sessionStorage.getItem('user');
  //   this.fname = sessionStorage.getItem('fname');

  //   this.lname = sessionStorage.getItem('lname');


  //   if (this.user === '2') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '1') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '3') {
  //     this.userAdmin = false;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   }
  // }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }


  simpletest() {
      this.testschedulerservice.test_scheduler(this.test).subscribe(
      (data) => {

       this.result = data.results;
       this.user = sessionStorage.getItem('user');
       this.fname = sessionStorage.getItem('fname');

       this.lname = sessionStorage.getItem('lname');


       this.dataSource = new MatTableDataSource(this.result);
       this.dataSource.sort=this.sort;
       setTimeout(() => this.dataSource.paginator = this.paginator);


       if (this.user === '2') {

        this.result = data.results;
        this.dataSource = new MatTableDataSource(this.result);
        this.dataSource.sort=this.sort;
        setTimeout(() => this.dataSource.paginator = this.paginator);

        return this.result;
       } else if ( this.user === '1') {
        this.result = data.results;
        return this.result;
       } else if ( this.user === '3') {
        return this.result;
       }
      },
      err => {
        console.error(err);
      }
    );
  }
  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }
  edit(user) {


    this.router.navigate(['/edit', user.id]);
  }

  delete(user) {

    

      Swal.fire({
        title: 'Are you sure want to delete?',
        text: 'You will not be able to recover later!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          this.adminservice.delete(user).subscribe(
            (data) => {
              // alert(data.success);
              window.location.reload();
      
              return;
            });}
          else if (result.dismiss === Swal.DismissReason.cancel) {
    
          }
        })
          
    
  }

  OnAddTestScheduler(form: NgForm) {

    this.router.navigateByUrl('/createTestScheduler');
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  designTest() {
    this.router.navigateByUrl('/designTest');
  }
}
